module.exports = __webpack_public_path__ + "img/IMG_7204P .de3463f0.jpg";